module.exports = __webpack_public_path__ + "img/banner5.abcac0b8.png";